export default __webpack_public_path__ + "assets/vertical-dots.43afc18c.webp";